import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { Paper, Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import { ServicingTransfersGrid } from './servicingTransfersGrid';
import { ServicingTransferTabs } from '../../utils/constants';
import { useServicingTransfersStore } from '../../hooks/useServicingTransfersStore';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '1400px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}));

const TABS = [
  {
    value: ServicingTransferTabs.SERVICING_TRANSFER,
    label: 'Servicing Transfers',
  },
  {
    value: ServicingTransferTabs.BOARDED,
    label: 'Boarded',
  },
];

export const ServicingTransfersDashboard = observer(() => {
  const classes = useStyles();
  const { servicingTransfersStore } = useServicingTransfersStore();
  const { tab } = servicingTransfersStore;

  return (
    <Layout title="Servicing Transfers Dashboard" containerClass={classes.container}>
      <Box pb={2}>
        <Tabs
          selectedTab={TABS.findIndex(t => t.value == tab)}
          tabs={Object.values(TABS)}
          onTabChange={(e, i) => servicingTransfersStore.setTab(TABS[i].value)}
        />
      </Box>
      <Box display="flex" flexDirection="column" height="100%">
        <Box flex={1}>
          <Paper className={classes.paper}>
            <ServicingTransfersGrid />
          </Paper>
        </Box>
      </Box>
    </Layout>
  );
});
